import { useState } from 'react';

export const FAQS = [
  {
    q: '漫画人极速版的省流画质会降低阅读体验吗？',
    a: '不会。省流画质会自动选择合适的压缩档位，在保留分镜和文字清晰度的前提下减少图片体积。对追求极致省流的用户，还可以配合压缩图模式使用，观感依然流畅。',
  },
  {
    q: '压缩图模式和我平时看的漫画有什么区别？',
    a: '压缩图模式会优化漫画图片的编码和体积，单章下载体积可下降一半以上，加载更快。同一部漫画的画质差异肉眼几乎不可见，但省下的流量非常可观。',
  },
  {
    q: '流量监控怎么查看我用了多少流量？',
    a: '进入「设置 → 流量监控」即可查看按时间统计的流量消耗明细，包括每部漫画、每一话的用量，还能看到开启省流功能后为你节省的数据总量。',
  },
  {
    q: '开启仅WiFi下载后会不会耽误我下载漫画？',
    a: '不会。仅WiFi下载会智能等待你连接无线网络后再自动缓存，连接移动数据时不会消耗流量。想立即下载时可随时在单个作品内手动触发。',
  },
  {
    q: '低流量浏览和数据节省功能可以同时开启吗？',
    a: '可以。低流量浏览与数据节省属于互补功能，建议同时开启，从图片加载到后台同步进行全方位优化，达到最好的数据节省效果。',
  },
  {
    q: '省流设置适合哪些用户使用？',
    a: '适合所有希望控制流量消耗的用户，尤其是流量套餐较小、常年在户外或地铁等移动网络环境下追漫画的用户。开启后低流量浏览漫画更安心。',
  },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="mb-10 text-center md:mb-12">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
            <i className="ri-question-line"></i>
            常见问题
          </span>
          <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-4xl">
            关于省流的那些疑问
          </h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">
            整理了用户最常问的问题，帮你快速上手数据节省。
          </p>
        </div>

        <div className="space-y-3">
          {FAQS.map((item, idx) => {
            const active = openIndex === idx;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(active ? null : idx)}
                  aria-expanded={active}
                  className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left md:px-5"
                >
                  <h3 className="text-sm font-bold text-foreground-950 md:text-base">{item.q}</h3>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100">
                    <i
                      className={`text-foreground-600 transition-transform ${
                        active ? 'ri-subtract-line' : 'ri-add-line'
                      }`}
                    ></i>
                  </span>
                </button>
                {active && (
                  <p className="border-t border-background-200 px-4 py-4 text-sm leading-relaxed text-foreground-600 md:px-5">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}